import React, { useState } from "react";
import { Link } from "react-router-dom";
import { HiX, HiSpeakerphone } from "react-icons/hi";

const AnnouncementModal = () => {
  const [isVisible, setIsVisible] = useState(() => {
    return !localStorage.getItem("announcement-dismissed");
  });

  const handleClose = () => {
    localStorage.setItem("announcement-dismissed", "true");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={handleClose}
      />

      {/* Modal */}
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 animate-fade-in">
        {/* Close Button */}
        <button
          onClick={handleClose}
          className="absolute top-4 right-4 p-1 text-neutral hover:text-neutral-dark
                     hover:bg-gray-100 rounded-full transition-colors"
          aria-label="Close announcement"
        >
          <HiX className="w-5 h-5" />
        </button>

        {/* Content */}
        <div className="text-center">
          <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <HiSpeakerphone className="w-8 h-8 text-primary-500" />
          </div>

          <h3 className="text-xl font-bold text-neutral-dark mb-3">
            AI & Tech Curriculum
          </h3>

          <p className="text-neutral mb-6">
            Hands-on AI, coding and robotics for Grades 1-10. Develop 21st-century
            STEM skills in every classroom. Empower tomorrow's innovators!
          </p>

          <div className="flex justify-center">
            <Link
              to="/blog/ai-edu-tech-curriculum"
              onClick={handleClose}
              className="px-5 py-2.5 bg-primary-500 text-white font-medium rounded-lg
                         hover:bg-primary-600 transition-colors"
            >
              Learn More
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementModal;
